// extracted by mini-css-extract-plugin
export default {"container":"style_container__ZRYTs","parallax":"style_parallax__32ll8","main":"style_main__q-uZx","glass":"style_glass__u1I84","glass2":"style_glass2__NXh55"};